export const selectSidebarOpeningState = (state) => state.sidebar.isCollapsed;
